
$(window).scroll(function () {
  if (isScrolledIntoView($('.featured-collection-section .product-grid')) === true) {
    $('.featured-collection-section .product-grid').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
            {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }); 
    $('.featured-collection-section .product-grid').slick('refresh');
  } else {
     $('.featured-collection-section .product-grid').slick('unslick');
  }
});
/* home page best seller slider loading issue js end */

$(document).ready(function(){
/* bundle page slider product price update on variant change js start */  
  var Shopify = Shopify || {};
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
};
$(document).on('change','.js-variant-selector',function(e){
  var data_id = $(this).attr('data-form');
   
  let current_em = $(e.target);
  let price = $(current_em).find('option:selected').attr('data-price');
  let compare_at_price = $(current_em).find('option:selected').attr('data-compare_at_price');
  let price_formatted = Shopify.formatMoney(price,Shopify.money_format);
  let compare_at_price_formatted = Shopify.formatMoney(compare_at_price,Shopify.money_format);
  $('#pdp_price_'+data_id).text(price_formatted); 
  $('#pdp_compareatprice_'+data_id).text(compare_at_price_formatted);
  
  if(compare_at_price > 0) {
      $('#pdp_compareatprice_'+data_id).show();
  } else {
      $('#pdp_compareatprice_'+data_id).hide();
  }
});  
/* bundle page slider product price update on variant change js end */    
/* bundle page qty update js start */
$(document).on('click', '.qtybox .btnqty', function(){
  var qtyInput = $(this).parent('.qtybox').find('.quantity-input-btn');
  var qty = parseInt(qtyInput.val());
  if ($(this).hasClass('qtyplus')) {
    qty++;
  } else {
    if (qty > 1) {
      qty--;
    }
  }
  qty = isNaN(qty) ? 1 : qty;
  qtyInput.val(qty);
  $('.product-variant-id-quanity').attr('quantity', qty); // Update the quantity attribute
});  
/* bundle page qty update js end */  
 $('.customer-list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

/* Bundle page custom product get from product handle and append using js start */
$(".product-handle").each(function( index,value ) {
  prod_handle = $(value).text();
  jQuery.getJSON(window.Shopify.routes.root + 'products/'+prod_handle+'.js', function(product) {
  var html_data = '';
    var prod_img = product.featured_image;
    var prod_title = product.title;
    var prod_price = "$" + (product.price / 100).toFixed(2);
    var prod_url = product.url;
    var prod_first_var_id = product.variants[0].id;
    var prod_cprice = '';
    var section_id = $(".product-handle").attr('section-id');
    var sec_id = $(".product-slider").attr('sec-id');
    var index_count = index;
    var product_id = product.id;
   
    if (product.compare_at_price  > 0) {
      prod_cprice = "$" + (product.compare_at_price / 100).toFixed(2);
    }
    html_data = `<div class="product-item">
              <div class="pr-thumb">
                <a class="pr-inner" href="${prod_url}">
                  <img src="${prod_img}">
                </a>
              </div>
              <div class="pr-content">
                <form
                  action="/cart/add"
                  method="post"
                  enctype="multipart/form-data"
                  id="addToCartForm-`;
      html_data += section_id + index_count + `">
                  <a class="pr-inner" href="${prod_url}">
                    <h3>${prod_title}</h3>
                  </a>
                 
                    <div style="display: block; margin-left: auto; margin-right: auto; width: 50%"
                      class="yotpo bottomLine" 
                      data-product-id="${product_id}"
                      data-url="${prod_url}">
                    </div>
                     <h5 id="pdp_price_`+section_id + index_count+`" data-pdp-price>${prod_price}</h5>
                    <h5 id="pdp_compareatprice_`+section_id + index_count+`" data-pdp-compareatprice>${prod_cprice}</h5>`;
      
      if (product.variants[0].title == 'Default Title') {
        html_data += `<input type="hidden" value="${prod_first_var_id}" name="id">`;
      } else {
        
      html_data += `<div class="size-box`;
      if (product.variants[0].title == 'Default Title') {
        html_data += `hide-dropdown`;
      }
      html_data += `"><select name="id" data-form="`+section_id + index_count+`" class="js-variant-selector product-variants form-control product-form__variants">`;
  
      $(product.variants).each(function( index,value ) {  
          html_data += `<option value="${value.id}"`;
          if (value.id == product.variants[0].id) {
          html_data += `selected `;
          }  
          html_data += `data-price="${value.price}"
                data-compare_at_price="${value.compare_at_price}"
              >
                ${value.title} - ${Shopify.formatMoney(value.price,Shopify.money_format)}
              </option>`;
      });
      html_data += `            
                      </select>
                    </div>`;
      }   
      html_data += `<div class="quantity-box">
                    <div class="d-sm-flex joinbtn align-items-center ">
                      <div class="qtydiv">
                        <label for="Quantity" class="quantity-selector">Quantity</label>
                        <div class="qtybox">
                          <span class="btnqty qtyminus icon icon-minus">-</span>
                          <input
                            type="text"
                            id="quantity"
                            name="quantity"
                            value="1"
                            min="1"
                            class="quantity-selector quantity-input-btn"
                            readonly=""
                          >
                          <span class="btnqty qtyplus icon icon-plus">+</span>
                        </div>
                      </div>
                      <div class="add-to-cart">
                        <button
                          type="submit"
                          name="add"
                          class="btn-add-to-cart addToCartBtn"
                          data-loop="`;
                      html_data += section_id + index_count +`">Add to cart</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>`;
      $(value).parent('.product-slider').append(html_data);
  });
});  
/* Bundle page custom product get from product handle and append using js end */  
/* bundle page product form add to cart data post serially using ajax js start */  
$(document).on("click", ".addToCartBtn", function() {
  var this_val = $(this).attr('data-loop'); 
  var form2 = $('#addToCartForm-'+this_val);
  var obj = $(this);
    $.ajax({
      url: form2.attr('action'),
      type: 'post',
      dataType: 'json',
      data: form2.serialize(),
      success: function(data) { 
        setTimeout(function() {
          obj.html("Adding...");
        }, 1000);
        setTimeout(function() {
          obj.html("Thank you!");
        }, 2000); 
        setTimeout(function() {
          obj.html("Add to cart");
        }, 3000); 
      },
      error: function (data) {
        if(data.status == 422) {
            alert("This product is already soldout!");
        }
      }
    });
    return false;
  }); 
/* bundle page product form add to cart data post serially using ajax js end */ 
/* pdp page custom product image slider js start */  
$(".slider-for-pdp").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".slider-nav-pdp"
});
$(".slider-nav-pdp").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  vertical: true,
  asNavFor: ".slider-for-pdp",
  dots: false,
  focusOnSelect: true,
  verticalSwiping: true,
  responsive: [
        {
      breakpoint: 1200,
      settings: {
        vertical: false,
         slidesToShow: 2,
      }
    },
    {
      breakpoint: 992,
      settings: {
        vertical: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 1
      }
    }
  ]
});
/* pdp page custom product image slider js end */   


  // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  });
  
  
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");
});









